<template>
  <div id="app" v-resize:throttle="onResize" v-resize:debounce="onResizeEnd">
    <!-- <div id="header">Header</div> -->
    <router-view></router-view>
    <transition name="fade">
      <Legal v-show="legalVisible"></Legal>
    </transition>
  </div>
</template>

<script>
import resize from "vue-resize-directive";
import store from "@/store/index.js";
import Legal from "@/views/Legal.vue";
import mapState from "vuex";

export default {
  name: "App",
  mounted() {
    store.dispatch("device/updateMobileState", null, { root: true });
  },
  methods: {
    onResize() {
      // console.log("resize", element);
      store.dispatch("device/updateMobileState", null, { root: true });
    },
    onResizeEnd() {
      // console.log("on resize end");
      // Fixing the issue with vh where it doesn't take account of the browser bar and bottom tab.
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
    // handleLegalBtnClicked() {
    //   store.dispatch("general/setLegalVisible", true, { root: true });
    // }
  },
  computed: {
    legalVisible() {
      return this.$store.state.general.legalVisible;
    },
  },
  components: {
    Legal,
  },
  directives: {
    resize,
  },
};
</script>

<style lang="scss">
body {
  margin: 0px;
}

#app {
  display: block;
  overflow-y: hidden;
  background-color: white;
}

// Animation
.fade-enter-active {
  // animation: fade-in 5s;
  transition: opacity 0.2s, transform 0.25s;
  // transition: opacity 0.5s;
}
.fade-leave-active {
  // animation: fade-out 5s;
  transition: opacity 0.2s, transform 0.25s;
  // transition: opacity 0.5s;
}
.fade-enter {
  opacity: 0;
  transform: translateX(100%);
}

.fade-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
  transform: translateX(0);
}
</style>
